import React from "react";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./About.scss";

const About = () => {
  const viewResumeHandler = () => {
    window.open(images.resume, "_blank");
  };

  return (
    <>
      <div className="app__about-context app__flex">
        <div className="app__about-img app__flex">
          <div className="app__flex">
            <img src={images.aboutmine} alt="Profile" />
          </div>
        </div>
        <div className="app__about-data app__flex">
          <h2 className="head-text">
            About <span>ME</span>
          </h2>
          <p className="p-text">
            Hi there, I'm Lalith - a full stack web developer{" "}
            <em>(MERN stack)</em>. I develop beautiful and user-friendly
            websites. I like what I’m currently doing{" "}
            <em>(Web Development!…)</em> and very much interested in
            Cybersecurity. Challenging myself to learn new things and expanding
            my skillset. Talking about my personality, I describe myself as a
            result-oriented person; great team player yet competent solo worker
            and an efficient individual.
          </p>
          <div>
            <button className="portfolio-button" onClick={viewResumeHandler}>
              Resume
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
